import { create } from "zustand";

export interface ReactKeepAliveStore {
    keepAliveNames: string[];
    cacheFormMap: Map<string, string>;
    cacheFormArr: string[];
    addKeepAliveName: (name: string) => void;
    removeKeepAliveName: (name: string) => void;
    setKeepAliveNames: (names?: string[]) => void;
    addCacheForm: (name: string, fullPath: string) => void;
    deleteCacheForm: (name: string) => void;
}

/** 页面缓存 Store，保留旧版缓存表单最多 10 个和最近使用顺序。 */
export const useKeepAliveStore = create<ReactKeepAliveStore>((set, get) => ({
    keepAliveNames: [],
    cacheFormMap: new Map(),
    cacheFormArr: [],
    addKeepAliveName: name => {
        if (!get().keepAliveNames.includes(name)) {
            set({ keepAliveNames: [...get().keepAliveNames, name] });
        }
    },
    removeKeepAliveName: name => set({ keepAliveNames: get().keepAliveNames.filter(item => item !== name) }),
    setKeepAliveNames: (keepAliveNames = []) => set({ keepAliveNames }),
    addCacheForm: (name, fullPath) => {
        const cacheFormMap = new Map(get().cacheFormMap);
        const cacheFormArr = [...get().cacheFormArr];
        const previousPath = cacheFormMap.get(name);
        if (previousPath) {
            const index = cacheFormArr.indexOf(previousPath);
            if (index >= 0) {
                cacheFormArr.splice(index, 1);
            }
        }
        cacheFormMap.set(name, fullPath);
        cacheFormArr.push(fullPath);
        while (cacheFormArr.length > 10) {
            const expiredPath = cacheFormArr.shift();
            if (expiredPath) {
                for (const [cachedName, cachedPath] of cacheFormMap.entries()) {
                    if (cachedPath === expiredPath) {
                        cacheFormMap.delete(cachedName);
                    }
                }
            }
        }
        set({ cacheFormMap, cacheFormArr });
    },
    deleteCacheForm: name => {
        const cacheFormMap = new Map(get().cacheFormMap);
        const fullPath = cacheFormMap.get(name);
        if (!fullPath) {
            return;
        }
        cacheFormMap.delete(name);
        set({ cacheFormMap, cacheFormArr: get().cacheFormArr.filter(path => path !== fullPath) });
    }
}));

export interface ReactLayoutStore {
    isFullscreen: boolean;
    toggleFullscreen: () => void;
    setFullscreen: (isFullscreen: boolean) => void;
}

/** 布局级全屏状态，页面组件只依赖该状态，不再耦合 Vue directive。 */
export const useLayoutStore = create<ReactLayoutStore>(set => ({
    isFullscreen: false,
    toggleFullscreen: () => set(state => ({ isFullscreen: !state.isFullscreen })),
    setFullscreen: isFullscreen => set({ isFullscreen })
}));
